export default __webpack_public_path__ + "static/media/full-video-usage-range.79286264.svg";